import { Guid } from 'types/guid';

export const initialState: DeviceInfoState = {
  deviceId: ''
};

export interface DeviceInfoState {
  deviceId: Guid;
}



// WEBPACK FOOTER //
// ./src/pages/device-info/state.ts